import {
  presenceStreamChannelSchema,
  supportTicketAiActivityStreamChannelSchema,
  supportTicketBulkActionsStreamChannelSchema,
  supportTicketNotificationsStreamChannelSchema,
  userNotificationsStreamChannelSchema,
  widgetConversationsStreamChannelSchema,
} from "./definitions";
import { exampleStreamChannelSchema } from "./example";
import { tasksStreamChannelSchema } from "./tasks";

export const streamChannelSchemaRegistry = {
  example: exampleStreamChannelSchema,
  tasks: tasksStreamChannelSchema,
  "support-ticket-notifications": supportTicketNotificationsStreamChannelSchema,
  "support-ticket-bulk-actions": supportTicketBulkActionsStreamChannelSchema,
  "support-ticket-ai-activity": supportTicketAiActivityStreamChannelSchema,
  "user-notifications": userNotificationsStreamChannelSchema,
  "widget-conversations": widgetConversationsStreamChannelSchema,
  presence: presenceStreamChannelSchema,
} as const;

export type RegisteredStreamChannelName =
  keyof typeof streamChannelSchemaRegistry;

export type StreamChannelSchemaFor<
  TChannel extends RegisteredStreamChannelName,
> = (typeof streamChannelSchemaRegistry)[TChannel];

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  streamChannelNameSchema,
  type StreamChannelName,
} from "@redotech/effect-api-shared/models/stream-protocol";
